import React from "react";
import PageHero from "@/components/PageHero";
import { IMG } from "@/lib/siteData";
import { useLang } from "@/context/LangContext";

export default function ActualitesPage() {
    const { t } = useLang();
    const posts = [
        { img: IMG.road, title: t("[Titre de votre première actualité]", "[Title of your first news item]"), text: t("[Résumé de l'actualité : nouveau service, partenariat, événement…]", "[News summary: new service, partnership, event…]") },
        { img: IMG.sea, title: t("[Titre d'une actualité maritime]", "[Title of a sea freight news item]"), text: t("[Résumé de l'actualité à rédiger.]", "[News summary to write.]") },
        { img: IMG.air, title: t("[Titre d'une actualité aérienne]", "[Title of an air freight news item]"), text: t("[Résumé de l'actualité à rédiger.]", "[News summary to write.]") },
    ];
    return (
        <>
            <PageHero testid="news-hero" eyebrow={t("Actualités", "News")} img={IMG.air} title={t("Les dernières nouvelles de Kazem Logistics", "The latest news from Kazem Logistics")} />
            <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid md:grid-cols-3 gap-6">
                {posts.map((p, i) => (
                    <article key={i} data-testid={`news-card-${i}`} className="border border-slate-200 rounded-md overflow-hidden hover:shadow-lg transition-shadow">
                        <img src={p.img} alt="" className="h-44 w-full object-cover" />
                        <div className="p-5">
                            <span className="text-[11px] uppercase tracking-widest text-[#f26b1d] font-semibold">{t("Exemple", "Sample")}</span>
                            <h2 className="font-semibold text-lg mt-2">{p.title}</h2>
                            <p className="text-sm text-slate-600 mt-2">{p.text}</p>
                        </div>
                    </article>
                ))}
            </section>
        </>
    );
}
